import $ from 'jquery';
import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import answerimg from '../../images/answer.png';
import s from '../../services/allservices.jsx';
import '../../stylesheet/changepassword.css';
import LoaderSmall from "../loader/loader.jsx";
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth.js';
import OtpPopup from '../otp/OtpPopup.js';
import { withRouter } from 'react-router-dom';
const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    secretQues: state.secretQuesReducer.secretQues,
})

const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    fetchSecretQues(quesReceived) {
        dispatch(
            actions.secretQuesAction(quesReceived)
        )
    }
})

const JSEncrypt = window.JSEncrypt
class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            secret: "",
            value: null,
            oldPassword: "",
            newPassword: "",
            currentPassword: "",
            correctPassword: true,
            secretAnswer: "",
            secretQuestionCode: "FF",
            correctDob: true,
            secretPassword: '',
            toggleConfirmPINIcon: "fa fa-eye-slash",
            togglePass: "password",
            toggleConfirmPass: "password",
            togglePassIcon: "fa fa-eye-slash",
            toggleConfirmPassIcon: "fa fa-eye-slash",
            toggleLoginType: "password",
            toggleLoginIcon: "fa fa-eye-slash",
            toggleText: "password",
            otpOpen: false,
            otp: "",
            actionType: "",
            popupLoader: false,

            oldPasswordError: "",
            newPasswordError: "",
            confirmPasswordError: "",
            secretQuestionError: "",
            secretAnswerError: "",
            currentPasswordError: "",

        }
    }
    validateSecretForm = () => {
        const { currentPassword, value, secretAnswer, secretPassword } = this.state;

        let currentPasswordError = "";
        let secretQuestionError = "";
        let secretAnswerError = "";

        // if (!currentPassword) {
        //     currentPasswordError = "Current password is required";
        // }
        const passwd =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+\-,'#$%^&*])(?=.{8,})/;

        if (!currentPassword) {
            currentPasswordError = "Current password is required";
        }
        else if (!passwd.test(currentPassword)) {
            currentPasswordError =
                "Password must contain uppercase, lowercase, number and special character";
        }

        if (!value) {
            secretQuestionError = "Please select a secret question";
        }

        // if (!secretAnswer && !secretPassword) {
        //     secretAnswerError = "Secret answer is required";
        // }
        if (value === "DOB") {

            if (!secretPassword) {
                secretAnswerError = "Secret answer is required";
            }

        } else {

            if (!secretAnswer) {
                secretAnswerError = "Secret answer is required";
            }

        }

        this.setState({
            currentPasswordError,
            secretQuestionError,
            secretAnswerError,
        });
    };
    componentDidMount() {
        $(".toggle-password").click(function () {

            $(this).toggleClass("fa-eye fa-eye-slash");
            var input = $($(this).attr("toggle"));
            if (input.attr("type") === "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });
        this.props.fetchSecretQues(false)
    }


    handleSelect = (event, index, value) => {
        this.findDescription(value);
        this.setState({ value }, () => {
            this.setState({
                correctDob: true,
                secretAnswer: "",
                secretPassword: "",
                dateSelected: false
            }, () => this.validateSecretForm());
        });
    };
    // handleDate = (e, date) => {
    //     this.setState({
    //         secretPassword: this.converDate(date),
    //         dateSelected: true
    //     })
    // }
    handleDate = (e, date) => {
        this.setState({
            secretPassword: this.converDate(date),
            dateSelected: true
        }, () => this.validateSecretForm());
    };
    converDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
        ].join('-');
    }
    formatDate = (date) => {
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        return `${(day < 10) ? ('0' + day) : day}/${(month < 10) ? ('0' + month) : month}/${year}`
    }

    handelepassword = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        this.setState(
            {
                [name]: value
            },
            () => {

                this.validatePasswordForm();

            }
        );
    };
    removepassword = () => {
        this.setState({
            correctPassword: true
        })
    }
    // for otp open


    otpPopupOpenModal = (type) => {
        const {
            oldPassword, newPassword, confirmPassword, correctPassword,
            currentPassword, value, secretAnswer, secretPassword, correctDob
        } = this.state;

        // PASSWORD VALIDATIONS
        if (type === "PASSWORD") {
            if (correctPassword === false) {
                toast.error('Please check password format', {
                    position: "top-right", draggablePercent: 60, autoClose: 3000,
                    hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: false
                });
                return;
            }
            if (oldPassword === "" || newPassword === "" || confirmPassword === "") {
                toast.error('Please Enter Data In Required Fields', {
                    position: "top-right", draggablePercent: 60, autoClose: 3000,
                    hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: false
                });
                return;
            }
            if (newPassword !== confirmPassword) {
                toast.error('New Password And Confirm Password Should Be Same', {
                    position: "top-right", draggablePercent: 60, autoClose: 3000,
                    hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: false
                });
                return;
            }
            if (oldPassword === newPassword) {
                toast.error('New Password And old Password Should not Be Same', {
                    position: "top-right", autoClose: 3000,
                });
                return;
            }
        }

        // SECRET QUESTION VALIDATIONS
        if (type === "SECRET") {
            if (correctDob === false) {
                toast.error('Enter correct format', {
                    position: "top-right", draggablePercent: 60, autoClose: 3000,
                    hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: false
                });
                return;
            }
            if (currentPassword === "" || value === null || (secretAnswer === "" && secretPassword === "")) {
                toast.error('Please Enter Data In Required Fields', {
                    position: "top-right", draggablePercent: 60, autoClose: 3000,
                    hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: false
                });
                return;
            }
        }

        const otpValidation = localStorage.getItem('otpValidation');

        // Store actionType first, then branch
        this.setState({ actionType: type }, () => {

            if (otpValidation === 'false') {
                // Skip OTP modal — call final API directly
                this.setState({ otp: "" }, () => {
                    if (type === "PASSWORD") {
                        this.handleSubmit(null, null);
                    } else if (type === "SECRET") {
                        this.changeSecretQuestion(null, null);
                    }
                });
            } else {
                // Show OTP modal as usual
                this.setState({ otpOpen: true }, () => {
                    this.handleRequestOtp(false);
                });
            }
        });
    };

    // for otp close
    otpPopupCloseModal = () => {

        this.setState({
            otpOpen: false,
        });
    };

    // OTP submit

    handleOtpSubmit = (otp, onSuccess, onError) => {

        this.setState({
            otp: otp,
            popupLoader: true,
        }, () => {

            if (this.state.actionType === "PASSWORD") {

                this.handleSubmit(onSuccess, onError);

            } else if (this.state.actionType === "SECRET") {

                this.changeSecretQuestion(onSuccess, onError);

            }

        });

    };




    handleRequestOtp = (resendOtp = false) => {
        let token = "Token " + localStorage.getItem("token");

        let plink =
            localStorage.getItem("pform") === "AU"
                ? process.env.REACT_APP_SERVICEURL_AU
                : process.env.REACT_APP_SERVICEURL_NZ;

        let traceId = getClientId();

        let otpUrl =
            this.state.actionType === "SECRET"
                ? s.otp_change_seq_que
                : s.otp_change_password;

        if (resendOtp) {
            otpUrl = `${otpUrl}/true`;
        }

        fetch(plink + otpUrl, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: token,
                "X-Trace-Id": traceId,
                "X-Client-APP": buildClientHeader(),
            })
        })
            .then((response) => {
                if (response.status === 200 || response.status === 201 || response.status === 204) {
                    toast.success(response.headers.get("message"), {
                        position: "top-right",
                        autoClose: 3000,
                    });
                }
                else if (response.status === 401) {
                    if (this.props.history !== undefined) {
                        this.props.history.push('/sessionout');
                    }
                }
                else {
                    toast.error(response.headers.get("message"), {
                        position: "top-right",
                        autoClose: 3000,
                    });
                }
            });
    };
    findDescription(value) {
        const { secretQues } = this.props
        for (let i = 0; i < secretQues.body.length; i++) {
            if (secretQues.body[i].secretQuestionCode === value) {
                this.setState({ description: secretQues.body[i].description })
            }
        }
    }


    onChange = (e) => {
        const name = e.target.name;

        this.setState(
            { [name]: e.target.value },
            () => {
                if (name === "oldPassword" || name === "confirmPassword") {
                    this.validatePasswordForm();
                }
                // if (name === "currentPassword") {
                //     this.validateSecretForm();
                // }
                if (name === "currentPassword") {
                    this.validateSecretForm();
                }
            }
        );
    };


    onChangeSecAns = (e, ansValue) => {
        const name = e.target.name;
        let _this = this;

        if (this.state.value !== "DOB") {
            this.setState({
                [name]: ansValue,
                correctDob: true,
            }, () => {
                if (_this.state.secretAnswer.length > 0) {
                    _this.setState({
                        correctDob: true,
                        secretPassword: ansValue
                    }, () => _this.validateSecretForm());
                } else {
                    _this.setState({
                        correctDob: true
                    }, () => _this.validateSecretForm());
                }
            });
        }
    };

    changeSecretQuestion(onSuccess, onError) {
        const { currentPassword } = this.state


        let state = {
            accountId: localStorage.getItem('accountId'),
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
            currentPassword: this.state.currentPassword,
            secretPassword: this.state.secretPassword,
            secretQuestionCode: this.state.value,
            otp: this.state.otp
        }

        let token = "Token " + localStorage.getItem('token')
        if (currentPassword !== '') {
            this.setState({
                loader: true
            })
            let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
            let traceId = getClientId();
            fetch(plink + s.change_seq_que, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': token,
                    'X-Trace-Id': traceId,
                    'X-Client-APP': buildClientHeader(),

                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        }, 3000);
                        if (onSuccess) {
                            onSuccess();
                        }

                        this.setState({
                            popupLoader: false,
                            loader: true
                        }, () => {

                            setTimeout(() => {

                                this.setState({
                                    loader: false
                                });

                                window.location.reload(true);

                            }, 3000);

                        });

                    }
                    else if ((response.status === 400)) {
                        // eslint-disable-next-line
                        this.setState({
                            popupLoader: false,
                            loader: false
                        })
                        if (onError) {
                            onError(response.headers.get('message'));
                        }
                        toast.error('Please Login Again'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        }
                        this.setState({
                            loader: false
                        })
                        // setTimeout(function () { window.location.reload(true); }, 1000);
                    }
                    else if (response.status === 422) {

                        this.setState({
                            popupLoader: false,
                            loader: false,
                        });
                        if (onError) {
                            onError(response.headers.get('message'));
                        }
                        let message = response.headers.get("message");

                        response.json().then((json) => {
                            message = json.message
                                ? json.message
                                : response.headers.get("message");

                            toast.error(message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                draggablePercent: 60,
                            });
                        });

                        // toast.error(message, {
                        //     position: "top-right",
                        //     autoClose: 3000,
                        //     hideProgressBar: false,
                        //     closeOnClick: true,
                        //     pauseOnHover: true,
                        //     draggable: true,
                        //     draggablePercent: 60,
                        // });

                    }
                    else if (response.status === 401) {

                        this.setState({
                            popupLoader: false,
                            loader: false
                        });

                        if (this.props.history !== undefined) {
                            this.props.history.push('/sessionout')
                        }

                    }
                    else {

                        this.setState({
                            popupLoader: false,
                            loader: false
                        });

                        if (onError) {
                            onError(response.headers.get('message'));
                        }

                        toast.error(
                            response.headers.get('message') || 'Please Enter Data In Required Fields',
                            {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            }
                        );
                    }
                })
        }


    }

    handleSubmit = (onSuccess, onError) => {
        const { oldPassword, newPassword, confirmPassword, correctPassword } = this.state

        const { publicKey } = this.props
        if (correctPassword === false) {
            this.setState({
                correctPassword: false,
            })
        }
        else {
            if (publicKey && publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);



                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    confirmPassword: encrypt.encrypt(confirmPassword),
                    newPassword: encrypt.encrypt(newPassword),
                    oldPassword: encrypt.encrypt(oldPassword),
                    accountId: encrypt.encrypt(localStorage.getItem("accountId")),
                    otp: this.state.otp
                }
                if (newPassword !== "" && oldPassword !== "" && confirmPassword !== "") {

                    let token = "Token " + localStorage.getItem('token')
                    if (newPassword === confirmPassword) {
                        this.setState({
                            loader: true
                        })
                        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                        let traceId = getClientId();
                        fetch(plink + s.change_password, {
                            method: 'POST',
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': token,
                                'X-Trace-Id': traceId,
                                'X-Client-APP': buildClientHeader(),

                            }),
                            body: JSON.stringify(state)
                        })
                            .then(response => {

                                if (response.status === 200 || response.status === 201) {
                                    toast.success(response.headers.get('message'), {
                                        position: "top-right",
                                        draggablePercent: 60,
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: false
                                    }, 3000);
                                    if (onSuccess) {
                                        onSuccess();
                                    }

                                    this.setState({
                                        popupLoader: false,
                                        loader: true
                                    }, () => {

                                        setTimeout(() => {

                                            this.setState({
                                                loader: false
                                            });

                                            window.location.reload(true);

                                        }, 3000);

                                    });
                                }
                                else if (response.status === 401) {

                                    this.setState({
                                        popupLoader: false,
                                        loader: false
                                    });

                                    if (this.props.history !== undefined) {
                                        this.props.history.push('/sessionout')
                                    }

                                }

                                else if (response.status === 422) {

                                    this.setState({
                                        popupLoader: false,
                                        loader: false,
                                    });
                                    if (onError) {
                                        onError(response.headers.get('message'));
                                    }
                                    let message = response.headers.get("message");

                                    response.text().then((text) => {
                                        if (text) {
                                            try {
                                                const json = JSON.parse(text);
                                                message = json.message ? json.message : message;
                                            } catch (e) {
                                                // empty or non-JSON body — fall back to header message
                                            }
                                        }

                                        toast.error(message, {
                                            position: "top-right",
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            draggablePercent: 60,
                                        });
                                    });

                                }
                                else {
                                    this.setState({
                                        popupLoader: false,
                                        loader: false
                                    })
                                    if (onError) {
                                        onError(response.headers.get('message'));
                                    }
                                    toast.error(response.headers.get('message'), {
                                        position: "top-right",
                                        draggablePercent: 60,
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: false
                                    });
                                    this.setState({
                                        loader: false
                                    })
                                    // setTimeout(function () { window.location.reload(true); }, 1000);
                                }
                            })
                    } else {
                        this.setState({
                            popupLoader: false,
                            loader: false
                        })
                        // eslint-disable-next-line
                        toast.error('New Password And Confirm Password Should Be Same'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        };
                        // setTimeout(function () { window.location.reload(true); }, 1000);

                    }
                } else {
                    this.setState({
                        popupLoader: false,
                        loader: false
                    })
                    // eslint-disable-next-line
                    toast.error('Please Enter Data In Required Fields'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    };
                    setTimeout(function () { window.location.reload(true); }, 3000);
                }
            }
        }
    }


    toggleCureentPass = () => {
        if (this.state.toggleText === "password") {
            this.setState({
                toggleText: "text",
                toggleConfirmPINIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                toggleText: "password",
                toggleConfirmPINIcon: "fa fa-eye-slash"
            })
        }
    }
    togglePassword = () => {

        if (this.state.togglePass === "password") {
            this.setState({
                togglePass: "text",
                togglePassIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                togglePass: "password",
                togglePassIcon: "fa fa-eye-slash"
            })
        }
    }
    toggleConfirmPassword = () => {
        if (this.state.toggleConfirmPass === "password") {
            this.setState({
                toggleConfirmPass: "text",
                toggleConfirmPassIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                toggleConfirmPass: "password",
                toggleConfirmPassIcon: "fa fa-eye-slash"
            })
        }
    }
    toggleLoginPassword = () => {

        if (this.state.toggleLoginType === "password") {
            this.setState({
                toggleLoginType: "text",
                toggleLoginIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                toggleLoginType: "password",
                toggleLoginIcon: "fa fa-eye-slash"
            })
        }
    }
    validatePasswordForm = () => {

        const {
            oldPassword,
            newPassword,
            confirmPassword
        } = this.state;

        let oldPasswordError = "";
        let newPasswordError = "";
        let confirmPasswordError = "";

        const passwd =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@.+\-,'#$%^&*])(?=.{8,})/;

        if (!oldPassword) {
            oldPasswordError = "Current password is required";
        }

        if (!newPassword) {
            newPasswordError = "New password is required";
        } else if (!passwd.test(newPassword)) {
            newPasswordError =
                "Password must contain uppercase, lowercase, number and special character";
        } else if (oldPassword === newPassword) {
            newPasswordError =
                "New password must differ from current password";
        }

        if (!confirmPassword) {
            confirmPasswordError = "Confirm password is required";
        } else if (newPassword !== confirmPassword) {
            confirmPasswordError =
                "New password and confirm password must match";
        }

        this.setState({
            oldPasswordError,
            newPasswordError,
            confirmPasswordError
        });
    };
    render() {
        const { secretQues } = this.props
        const { correctPassword, correctDob } = this.state

        const isPasswordFormValid =
            this.state.oldPassword &&
            this.state.newPassword &&
            this.state.confirmPassword &&
            !this.state.oldPasswordError &&
            !this.state.newPasswordError &&
            !this.state.confirmPasswordError;

        // const isSecretFormValid =
        //     this.state.currentPassword &&
        //     this.state.value &&
        //     (this.state.secretAnswer || this.state.secretPassword) &&
        //     !this.state.currentPasswordError &&
        //     !this.state.secretQuestionError &&
        //     !this.state.secretAnswerError;
        const isSecretFormValid =
            this.state.currentPassword &&
            this.state.value &&
            (
                this.state.value === "DOB"
                    ? this.state.secretPassword
                    : this.state.secretAnswer
            ) &&
            !this.state.currentPasswordError &&
            !this.state.secretQuestionError &&
            !this.state.secretAnswerError;
        return (
            <div style={{ padding: "0px 30px" }}>

                {this.state.otpOpen && (

                    <OtpPopup
                        open={this.state.otpOpen}
                        onClose={this.otpPopupCloseModal}
                        handleRequestOtp={this.handleRequestOtp}
                        onSubmit={this.handleOtpSubmit}
                        loading={this.state.popupLoader}
                    />
                )}
                <div className="col-md-12 p-0 mt-3" >
                    {/* {this.state.loader ? <div style={{ marginTop: "200px" }}><LoaderSmall /></div> : */}
                    {(this.state.loader && !this.state.popupLoader) ? (
                        <div style={{ marginTop: "200px" }}>
                            <LoaderSmall />
                        </div>
                    ) :
                        <div className="row">
                            <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                <h4 className='logmainheading mainheading'>
                                    Password / Secret Q&A
                                </h4>
                            </div>

                            <div className="col-sm-12 mb-3" >
                                <div className="row">

                                    <div className="col-md-12" style={{ padding: "0px" }}>
                                        <div className="summary-header">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <span>Change Password</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" col-md-12 col-sm-12 mb-3">
                                        <div className="row input-group" >
                                            {/* <div className="col-sm-2 passinput" >
                                                <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                            </div> */}
                                            <div className="col-sm-3" >
                                                <TextField
                                                    hintText="Start Typing.."
                                                    floatingLabelText="Current Password"
                                                    type={this.state.toggleText} maxLength="15"
                                                    id="currentpassword"
                                                    name="oldPassword"
                                                    autoComplete='none'
                                                    className="input-width required"
                                                    onChange={this.onChange}
                                                    errorText={this.state.oldPasswordError}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                />
                                            </div>

                                            <div className="col-sm-1" style={{ padding: "0px 0px" }}>
                                                <span toggle="#currentpassword" className={`${this.state.toggleConfirmPINIcon} field-icon toggle-password`} style={{ marginTop: "40px", marginLeft: "-12px", cursor: "pointer" }} onClick={this.toggleCureentPass} ></span>
                                                {/* <span toggle="#currentpassword" className="fa fa-fw fa-eye-slash  field-icon toggle-password" style={{ marginTop: "45px", marginLeft: "-12px" }} ></span> */}
                                            </div>
                                            <div className="col-sm-3" >
                                                <TextField
                                                    hintText="Start Typing.."
                                                    floatingLabelText="New Password"
                                                    type={this.state.togglePass}
                                                    id="newPassword"
                                                    autoComplete='none'
                                                    maxLength="15"
                                                    name="newPassword"
                                                    className="input-width required"
                                                    onChange={this.handelepassword}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                    errorText={this.state.newPasswordError}
                                                // errorText={correctPassword ? null : "Please check help button"}
                                                />
                                                <span className="tooltip" style={{ top: "35px", right: "5px" }}>

                                                    <i className="fa fa-question-circle" aria-hidden="true"></i>
                                                    <span className="tooltiptext" style={{ fontSize: "12px", top: "-65px", left: "-100px" }} >Your Password must contain at least 8 characters including one number, one lowercase letter, one uppercase letter and a special character. As an example, Rainbow123! </span>

                                                </span>

                                            </div>
                                            <span toggle="#newPassword" className={`${this.state.togglePassIcon} field-icon toggle-password`} style={{ marginTop: "40px", marginLeft: "5px", cursor: "pointer" }} onClick={this.togglePassword} ></span>


                                            <div className="col-sm-4" >
                                                <div className="row">
                                                    <div className="col-sm-10 offset-sm-1" style={{ paddingRight: "0px" }}>
                                                        <TextField
                                                            hintText="Start Typing.."
                                                            floatingLabelText="Confirm New Password"
                                                            type={this.state.toggleConfirmPass}
                                                            id="loginpassword"
                                                            maxLength="15"
                                                            name="confirmPassword"
                                                            autoComplete='none'
                                                            className="input-width required"
                                                            style={{ zIndex: "0" }}
                                                            onChange={this.onChange}
                                                            errorText={this.state.confirmPasswordError}
                                                            underlineFocusStyle={styles.focusStyle}
                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                        />
                                                    </div>
                                                    <span toggle="#loginpassword" className={`${this.state.toggleConfirmPassIcon} field-icon toggle-password`} style={{ marginTop: "40px", marginLeft: "-5px", cursor: "pointer" }} onClick={this.toggleConfirmPassword} ></span>
                                                    {/* <div className="col-sm-2" style={{ padding: "0px 5px" }}>
                                                        <span toggle="#loginpassword" className="fa fa-fw fa-eye-slash field-icon toggle-password" style={{ position: "relative", color: "#333", top: "45px" }}></span>
                                                    </div> */}
                                                </div>
                                            </div>


                                        </div>

                                    </div>

                                    <div className=" col-sm-3">
                                        <RaisedButton
                                            label="Change"
                                            className="pull-left btn-std"
                                            // style={styles.button}
                                            disabled={!isPasswordFormValid}

                                            backgroundColor="#FFCE39"
                                            labelColor="#115876"
                                            onClick={() => this.otpPopupOpenModal("PASSWORD")}
                                            style={{ marginTop: "10px" }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 mt-3">
                                <div className="row">
                                    <div className="col-md-12" style={{ padding: "0px" }}>
                                        <div className="summary-header">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <span>Change Secret Question</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" col-md-12 col-sm-12">
                                        <div className="row input-group" >
                                            {/* <div className="col-sm-2 input-icon" >
                                                <i className="fa fa-key text-dark " aria-hidden="true"></i>
                                            </div> */}
                                            <div className="col-sm-3" >
                                                <TextField
                                                    hintText="Start Typing.."
                                                    floatingLabelText="Current Password"
                                                    type={this.state.toggleLoginType}
                                                    name="currentPassword"
                                                    id="oldPassword1"
                                                    autoComplete='none'
                                                    maxLength="15"
                                                    className="input-width required"
                                                    onChange={this.onChange}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                    errorText={this.state.currentPasswordError}
                                                />
                                            </div>
                                            <div className="col-sm-1" style={{ padding: "0px 0px" }}>
                                                <span toggle="#oldPassword1" className={`${this.state.toggleLoginIcon} field-icon toggle-password`} style={{ marginTop: "40px", marginLeft: "-5px", cursor: "pointer" }} onClick={this.toggleLoginPassword} ></span>
                                            </div>

                                            {/* <div className="col-sm-1" style={{ padding: "0px 0px" }}>
                                                <span toggle="#oldPassword1" className="fa fa-fw fa-eye-slash field-icon toggle-password" style={{ marginTop: "45px", marginLeft: "-12px" }} ></span>
                                            </div> */}

                                            <div className="col-sm-3" >
                                                <SelectField
                                                    value={this.state.value}

                                                    onChange={this.handleSelect}
                                                    name="secretQuestionCode"
                                                    autoComplete='none'
                                                    floatingLabelText="Secret Question"
                                                    className="input-width required"
                                                    errorText={this.state.secretQuestionError}

                                                >
                                                    {(secretQues.message === "Success") ? secretQues.body.map((value, i) =>
                                                        <MenuItem className="menuitem" value={secretQues.body[i].secretQuestionCode} primaryText={secretQues.body[i].description} key={i} />
                                                    ) : <div>Select Question</div>}
                                                </SelectField>
                                            </div>

                                            <div className="col-sm-4 ml-4">
                                                {(this.state.value === "DOB") ?

                                                    <DatePicker hintText="Birthday"
                                                        //  container="inline" mode="landscape"
                                                        openToYearSelection={true}
                                                        floatingLabelText="Secret Answer(Date Of Birth)"
                                                        style={{ width: "100%" }}
                                                        type="text"
                                                        name="secretAnswer"
                                                        onChange={this.handleDate}
                                                        maxDate={new Date()}
                                                        formatDate={this.formatDate}
                                                        className="input-width required"
                                                        errorText={this.state.secretAnswerError}

                                                        // defaultValue={this.state.secretAnswerDate || null}
                                                        // defaultDate={( new Date(this.state.secretAnswerDate))} 
                                                        // defaultDate={ this.state.secretAnswerDate}
                                                        defaultDate={(this.state.secretAnswerDate) ? new Date(this.state.secretAnswerDate) : this.state.secretAnswerDate}

                                                        // defaultDate={new Date()}
                                                        // defaultDate= {new Date()}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle} />
                                                    :
                                                    <TextField
                                                        hintText={(this.state.value === "DOB") ? "DD/MM/YYYY" : "Start Typing.."}
                                                        floatingLabelText="Secret Answer"
                                                        type="text"
                                                        name="secretAnswer"
                                                        maxLength="50"
                                                        className="input-width required"
                                                        onChange={this.onChangeSecAns}
                                                        autoComplete='off'
                                                        // autoComplete='none'
                                                        // onBlur={this.onBlurSecAns}
                                                        underlineFocusStyle={styles.focusStyle}
                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                        // errorText={correctDob ? null : "Enter correct format"}
                                                        errorText={this.state.secretAnswerError || (correctDob ? null : "Enter correct format")}
                                                    />
                                                }
                                            </div>
                                        </div>

                                    </div>
                                    <div className=" col-sm-3">
                                        <RaisedButton
                                            label="Change"
                                            className="pull-left btn-std"
                                            disabled={!isSecretFormValid}
                                            // style={styles.button}
                                            backgroundColor="#FFCE39"
                                            labelColor="#115876"
                                            onClick={() => this.otpPopupOpenModal("SECRET")}
                                            style={{ marginTop: "10px" }}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>}
                </div>

            </div>
        );
    }
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
);


// WEBPACK FOOTER //
// ./src/components/myprofile/changepassword.jsx